<style scoped lang="less" rel="stylesheet/less">
.password {
  background: #0089ce 100%;
  position: relative;
  height: 100%;
  .content {
    position: relative;
    left: 50%;
    top: 50%;
    transform: translate(-272px, -272px);
    width: 543px;
    height: 543px;
    .sx_box {
      width: 100%;
      height: 100%;
      background: url("../../../assets/img/password/password_ground.png") center
        no-repeat;
      background-size: 100%;
      /*animation: roate 1s;*/
      .img_box:hover i {
        display: block;
      }
      i {
        background: url("../../../assets/img/password/qipao_right.png")
          no-repeat center;
        background-size: 100%;
        width: 172px;
        height: 146px;
        font-size: 55px;
        color: #fff;
        line-height: 146px;
        display: none;
        z-index: 20;
        position: absolute;
        pointer-events: none;
      }
      em {
        position: absolute;
        width: 72px;
        height: 72px;
        border-radius: 50%;
        background: #003057;
        opacity: 0.4;
        z-index: 999;
        display: none;
      }
      .animation_move1 {
        z-index: 10;
        animation: move1 0.4s;
      }
      .animation_move2 {
        z-index: 10;
        animation: move2 0.4s;
      }
      .animation_move3 {
        z-index: 10;
        animation: move3 0.4s;
      }
      .shu {
        top: 421px;
        left: 237px;
      }
      .shu + i {
        top: 358px;
        left: 302px;
      }
      .niu {
        top: 397px;
        left: 140px;
      }
      .niu + i {
        top: 332px;
        left: -25px;
        background: url("../../../assets/img/password/qipao_left.png") no-repeat
          center;
        background-size: 100%;
      }
      .hu {
        top: 328px;
        left: 76px;
      }
      .hu + i {
        top: 262px;
        left: -90px;
        background: url("../../../assets/img/password/qipao_left.png") no-repeat
          center;
        background-size: 100%;
      }
      .tu {
        top: 236px;
        left: 51px;
      }
      .tu + i {
        top: 172px;
        left: -115px;
        background: url("../../../assets/img/password/qipao_left.png") no-repeat
          center;
        background-size: 100%;
      }
      .long {
        top: 145px;
        left: 76px;
      }
      .long + i {
        top: 81px;
        left: -90px;
        background: url("../../../assets/img/password/qipao_left.png") no-repeat
          center;
        background-size: 100%;
      }
      .she {
        top: 77px;
        left: 140px;
      }
      .she + i {
        top: 12px;
        left: -25px;
        background: url("../../../assets/img/password/qipao_left.png") no-repeat
          center;
        background-size: 100%;
      }
      .ma {
        top: 51px;
        left: 237px;
      }
      .ma + i {
        top: -14px;
        left: 302px;
      }
      .yang {
        top: 77px;
        left: 332px;
      }
      .yang + i {
        top: 12px;
        left: 394px;
      }
      .hou {
        top: 145px;
        left: 398px;
      }
      .hou + i {
        top: 81px;
        left: 463px;
      }
      .ji {
        top: 236px;
        left: 422px;
      }
      .ji + i {
        top: 172px;
        left: 487px;
      }
      .gou {
        top: 328px;
        left: 398px;
      }
      .gou + i {
        top: 262px;
        left: 463px;
      }
      .zhu {
        top: 397px;
        left: 332px;
      }
      .zhu + i {
        top: 332px;
        left: 394px;
      }
    }
    .mima_box {
      span {
        top: 236px;
        position: absolute;
        background: url("../../../assets/img/password/mima_fill.png") center
          no-repeat;
        background-size: 100%;
        img {
          width: 74px;
          height: 74px;
          border-radius: 37px;
        }
      }
      .shake {
        animation: shake 0.5s cubic-bezier(0.645, 0.045, 0.355, 1);
      }
      .hidden {
        animation: zoomOut 0.5s;
      }
      .bogin_bg_0 {
        width: 74px;
        height: 74px;
        left: 146px;
      }
      .bogin_bg_1 {
        width: 74px;
        height: 74px;
        left: 235px;
      }
      .bogin_bg_2 {
        width: 74px;
        height: 74px;
        left: 324px;
      }
    }
    .tishi {
      position: absolute;
      top: 165px;
      left: 229px;
      font-size: 21px;
      color: #00547E;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      letter-spacing: 0;
      line-height: 42px;
    }
    .clearpassword {
      position: absolute;
      color: #00547E;
      font-family: PingFangSC, PingFangSC-Regular;
      font-weight: 400;
      top: 354px;
      left: 252px;
      font-size: 21px;
    }
    .sx_img {
      position: absolute;
      width: 72px;
      height: 72px;
      box-shadow: 1px 2px #003057;
      border-radius: 37px;
    }
    .img_box:active em {
      display: block;
    }
  }
  .forgetpwd{
    position: absolute;
    right: 85px;
    bottom: 135px;
    display: flex;
    align-items: center;
    height: 30px;
    font-size: 21px;
    font-family: PingFangSC, PingFangSC-Regular;
    font-weight: 200;
    text-align: left;
    color: #cce4eb;
    line-height: 30px;
    img{
      width: 8px;
      height: 15px;
      margin-left: 14px;
    }
  }
}
</style>
<template>
  <div class="password">
    <Back @goBack="goback" />
    <div class="content">
      <div class="sx_box">
        <div class="img_box" v-for="(item,index) in sxList" :key="index">
          <img
            ondragstart="return false;"
            :class="[index==clickindex? className:'','sx_img',item.className,'cursor']"
            :src="item.normal"
          />
          <img
            ondragstart="return false;"
            :class="['sx_img',item.className,'cursor']"
            :src="item.normal"
            alt="加载失败"
          />
          <i>{{item.classNameCn}}</i>
          <em :class="item.className" @mouseup="chooseUserClick(item.dataVal,item.normal,index)"></em>
        </div>
      </div>
      <span class="tishi" :style="{'color':Message=='密码错误'?' #f54322':''}">{{Message}}</span>
      <div class="mima_box">
        <span :class="['bogin_bg_0',shake? 'shake':'' ]">
          <img
            ondragstart="return false;"
            v-show="passwordList[0]"
            :class="[hidden? 'hidden':'' ]"
            :src="passwordList[0]"
          />
        </span>
        <span :class="['bogin_bg_1',shake? 'shake':'' ]">
          <img
            ondragstart="return false;"
            v-show="passwordList[1]"
            :class="[hidden? 'hidden':'' ]"
            :src="passwordList[1]"
          />
        </span>
        <span :class="['bogin_bg_2',shake? 'shake':'' ]">
          <img
            ondragstart="return false;"
            v-show="passwordList[2]"
            :class="[hidden? 'hidden':'' ]"
            :src="passwordList[2]"
          />
        </span>
      </div>
      <span class="clearpassword cursor" @click="clearPassword">清空</span>
    </div>
    <icp />
    <div class="forgetpwd cursor" @click="goPage('reset')">
      <div>忘记密码</div>
      <img ondragstart="return false;" src="../../../assets/img/password/forgetarr.png" alt="">
    </div>
    <alert
      :sameOne="alertText"
      cancal="忘记密码"
      btn="验证码登录"
      v-if="alertText"
      :show="!!alertText"
      @cancelEvent="goPage('reset')"
      @ensure="goPage('login')"
    ></alert>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import Back from "@/components/basic/back.vue";
import icp from "@/components/basic/icp.vue";
import alert from "@/components/basic/alert.vue";
import md5 from "js-md5";
export default {
  data() {
    return {
      Message: "输入密码",
      hidden: false,
      userPwd: "",
      shake: false,
      clickindex: null,
      classIndex: -1,
      classList: ["animation_move1", "animation_move2", "animation_move3"],
      passwordList: [],
      alertText:"",
      sxList: [
        {
          normal: "/static/img/sx/shu.png",
          dataVal: "01",
          className: "shu",
          classNameCn: "鼠"
        },
        {
          normal: "/static/img/sx/niu.png",
          dataVal: "02",
          className: "niu",
          classNameCn: "牛"
        },
        {
          normal: "/static/img/sx/hu.png",
          dataVal: "03",
          className: "hu",
          classNameCn: "虎"
        },
        {
          normal: "/static/img/sx/tu.png",
          dataVal: "04",
          className: "tu ",
          classNameCn: "兔"
        },
        {
          normal: "/static/img/sx/long.png",
          dataVal: "05",
          className: "long ",
          classNameCn: "龙"
        },
        {
          normal: "/static/img/sx/she.png",
          dataVal: "06",
          className: "she",
          classNameCn: "蛇"
        },
        {
          normal: "/static/img/sx/ma.png",
          dataVal: "07",
          className: "ma",
          classNameCn: "马"
        },
        {
          normal: "/static/img/sx/yang.png",
          dataVal: "08",
          className: "yang",
          classNameCn: "羊"
        },
        {
          normal: "/static/img/sx/hou.png",
          dataVal: "09",
          className: "hou",
          classNameCn: "猴"
        },
        {
          normal: "/static/img/sx/ji.png",
          dataVal: "10",
          className: "ji",
          classNameCn: "鸡"
        },
        {
          normal: "/static/img/sx/gou.png",
          dataVal: "11",
          className: "gou",
          classNameCn: "狗"
        },
        {
          normal: "/static/img/sx/zhu.png",
          dataVal: "12",
          className: "zhu",
          classNameCn: "猪"
        }
      ]
    };
  },
  components: { icp, Back , alert},
  computed: {
    ...mapState(["phone"]),
    className() {
      if (this.classIndex != -1) {
        return this.classList[this.classIndex];
      }
    }
  },
  created() {
    if (!this.COOK && !this.phone) {
      this.$router.replace("/");
    }
    if (this.COOK) {
      this.$router.replace("/class");
    }
  },
  mounted() {},
  methods: {
    ...mapActions(["getLoginInfo"]),
    ...mapMutations(["refreshNet","saveFirstLogin"]),
    //=>校验密码
    checkPassword() {
      if (!navigator.onLine) {
        this.refreshNet(false);
        this.clearPassword();
        return;
      }
      this.Message = "登录中···";
      this.getLoginInfo({
        username: this.phone,
        password: md5(this.userPwd),
        usertype: "student",
        from: LIMI_ENV === "electron" ? "live_pc_h5" : "live_pc_web"
      }).then(({ res, ok }) => {
          this.$root.eventHub.$emit("createLog", {
            id: "LMTrackEventLoginSuccess",
            data: {
              result: res.code || "E_SUCCESS",
              content: res.desc || "操作成功"
            }
          });
          if (ok) {
            this.Message = "登录成功";
            this.saveFirstLogin(res.first_login_check==0?1:0)
            this.$router.replace({
              name: "class",
              params: {
                from: "first"
              }
            });
          } else {
            if(res.code==2037){
              this.alertText = res.desc
            }
            this.$root.eventHub.$emit("createLog", {
              id: "LMTrackEventLoginError",
              data: {}
            });
            this.Message = "密码错误";
            this.shake = true;
            setTimeout(() => {
              this.hidden = true;
              this.shake = false;
              this.clearPassword();
            }, 1000);
          }
        })
        .catch(err => {
          this.clearPassword();
          this.$root.eventHub.$emit("createLog", {
            id: "LMTrackEventLoginSuccess",
            data: {
              result: 500,
              content: err
            }
          });
        });
    },
    //返回登录页面
    goback() {
      this.$router.push("/login");
    },
    //密码重置
    goPage(type) {
      this.$router.replace({path:"/passwordreset",query:{
        type:type
      }});
    },
    //清除密码
    clearPassword(event) {
      this.hidden = true;
      setTimeout(() => {
        this.classIndex = -1;
        this.passwordList = [];
      }, 300);
      this.Message = "输入密码";
      this.userPwd = "";
    },
    //点击密码图
    chooseUserClick(id, src, idx) {
      if (this.passwordList.length === 3 || this.clickindex != null) return;
      this.classIndex += 1;
      this.clickindex = idx;
      setTimeout(() => {
        this.hidden = false;
        this.clickindex = null;
        this.passwordList.push(src);
        this.userPwd += id;
        if (this.passwordList.length === 3) {
          this.checkPassword();
        }
      }, 400);
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/bussiness/password/password.vue